export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';

//CATEGORIES
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const CATEGORY_ERROR = 'CATEGORY_ERROR';
export const GET_CATEGORY = 'GET_CATEGORY';

//SERVICES
export const GET_SERVICES = 'GET_SERVICES';
export const ADD_SERVICE = 'ADD_SERVICE';
export const SERVICE_ERROR = 'SERVICE_ERROR';

//SERVICE TYPES
export const GET_SERVICE_TYPES = 'GET_SERVICE_TYPES';
export const ADD_SERVICE_TYPE = 'ADD_SERVICE_TYPE';
export const SERVICE_TYPE_ERROR = 'SERVICE_TYPE_ERROR';


//PRICE TYPES
export const GET_PRICE_TYPES = 'GET_PRICE_TYPES';
export const ADD_PRICE_TYPE = 'ADD_PRICE_TYPE';
export const PRICE_TYPE_ERROR = 'PRICE_TYPE_ERROR';


//DURATIONS
export const GET_DURATIONS = 'GET_DURATIONS';
export const ADD_DURATION = 'ADD_DURATION';
export const DURATION_ERROR = 'DURATION_ERROR';


//CATEGORY WISE SERVICES
export const GET_CATEGORY_WISE_SERVICES = 'GET_CATEGORY_WISE_SERVICES';
export const CATEGORY_WISE_SERVICE_ERROR = 'CATEGORY_WISE_SERVICE_ERROR';


//WEEK DAYS
export const UPDATE_WEEK_DAYS = 'UPDATE_WEEK_DAYS';
export const GET_WEEK_DAYS = 'GET_WEEK_DAYS';
export const WEEK_DAY_ERROR = 'WEEK_DAY_ERROR';


//INTERVALS 
export const GET_INTERVAL_TYPES = 'GET_INTERVAL_TYPES';
export const INTERVAL_ERROR = 'INTERVAL_ERROR';


//SERVICE INTERVALS
export const GET_SERVICE_INTERVAL = 'GET_SERVICE_INTERVAL';
export const UPDATE_SERVICE_INTERVAL = 'UPDATE_SERVICE_INTERVAL';
export const SERVICE_INTERVAL_ERROR = 'SERVICE_INTERVAL_ERROR';
export const RESET_SERVICE_INTERVAL = 'RESET_SERVICE_INTERVAL';


//BRANDING LOGO
export const BUSINESS_INFO_UPDATED = 'BUSINESS_INFO_UPDATED';
export const BUSINESS_INFO_ERROR = 'BUSINESS_INFO_ERROR';


//APPOINTMENTS
export const GET_APPOINTMENT_COUNT = 'GET_APPOINTMENT_COUNT';
export const APPOINTMENT_COUNT_ERROR = 'APPOINTMENT_COUNT_ERROR';

export const GET_LATEST_APPOINTMENTS = 'GET_LATEST_APPOINTMENTS';
export const LATEST_APPOINTMENTS_ERROR = 'LATEST_APPOINTMENTS_ERROR';
export const GET_ALL_APPOINTMENTS = 'GET_ALL_APPOINTMENTS';
export const ALL_APPOINTMENTS_ERROR = 'ALL_APPOINTMENTS_ERROR';


// APPOINTMENTS - UPCOMING
export const GET_UPCOMING_APPOINTMENTS = 'GET_UPCOMING_APPOINTMENTS';
export const UPCOMING_APPOINTMENTS_ERROR = 'UPCOMING_APPOINTMENTS_ERROR';
export const GET_UPCOMING_APPOINTMENT = 'GET_UPCOMING_APPOINTMENT';
export const UPDATE_UPCOMING_APPOINTMENT = 'UPDATE_UPCOMING_APPOINTMENT';


// APPOINTMENTS - PAST
export const GET_PAST_APPOINTMENTS = 'GET_PAST_APPOINTMENTS';
export const PAST_APPOINTMENTS_ERROR = 'PAST_APPOINTMENTS_ERROR';


// APPOINTMENT CANCEL 
export const GET_CANCEL_BOOKINGS = 'GET_CANCEL_BOOKINGS';
export const SUCCESS_CANCEL_BOOKING = 'SUCCESS_CANCEL_BOOKING';
export const CANCEL_BOOKING_ERROR = 'CANCEL_BOOKING_ERROR';
